export const selectStyle = {
  control: (provided, state) => ({
    ...provided,

    backgroundColor: "#50525d",
    color: "#eee",
    border: "0px",
    maxWidth: "100%",
    width: 'auto',
  }),
  container: (provided, state) => ({
    ...provided,
    maxWidth: "100%",
    width: "100%",
  }),
  noOptionsMessage: (provided, state) => ({
    ...provided,
    color: "green",
    maxWidth: "100%",
  }),
  input: (provided, state) => ({
    ...provided,
    color: "#eee",
    maxWidth: "100%",
  }),
  singleValue: (provided, state) => ({
    ...provided,
    color: "#eee",
  }),
  indicatorSeparator: (provided, state) => ({
    ...provided,
    background: "transparent",
  }),
  menu: (provided, state) => ({
    ...provided,
    backgroundColor: "#373842",
    maxWidth: "100%",
    zIndex: 100,
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? "#20a8d8" : "#3d3d3d",
    color: "#eee",
    ["&:hover"]: {
      backgroundColor: "#5a5959ba",
    },
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "#eee",
  }),
};
